import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '../../shared/icon/icon.component';
import { Document } from '../../../models/document';
import { getDocumentTypeLabel } from '../../../list/document-types';
import {
    selectShipmentEditorDocuments,
    selectShipmentEditorDeletingDocumentIds
} from '../../../store/shipment-editor/shipment-editor.state';
import { shipmentEditorDeleteDocumentRequest } from '../../../store/shipment-editor/shipment-editor.actions';

@Component({
    selector: 'app-shipment-documents',
    templateUrl: './shipment-documents.component.html',
    styleUrls: ['./shipment-documents.component.scss'],
    imports: [AsyncPipe, MatIconButton, MatProgressSpinner, MatTooltip, IconComponent]
})
export class ShipmentDocumentsComponent {

    constructor(private store: Store<AppState>) {}

    documents$: Observable<Document[]> = this.store.select(selectShipmentEditorDocuments);
    deletingDocumentIds$: Observable<string[]> = this.store.select(selectShipmentEditorDeletingDocumentIds);

    getDocumentTypeLabel = getDocumentTypeLabel;

    isDeleting(documentId: string, deletingIds: string[]): boolean {
        return deletingIds.includes(documentId);
    }

    deleteDocument(documentId: string): void {
        this.store.dispatch(shipmentEditorDeleteDocumentRequest({ documentId }));
    }
}
